'use client';

import { Component, PropsWithChildren } from 'react';

/**
 * Thrown intentionally from a modal's atom to signal that the underlying
 * resource (e.g. position) is gone and the modal should auto-close.
 * Use `instanceof ModalDismissSignal` to distinguish from real bugs.
 */
export class ModalDismissSignal extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ModalDismissSignal';
  }
}

interface Props extends PropsWithChildren {
  onError: (error: Error) => void;
}

interface State {
  hasError: boolean;
}

export class ModalErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    this.props.onError(error);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
